'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _curry = require('./curry');

var _curry2 = _interopRequireDefault(_curry);

var _setArity2 = require('./internal/_setArity');

var _setArity3 = _interopRequireDefault(_setArity2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Creates a function identical to `operation` but with length `arity`.
 *
 * @example
 * const op = (...args) => args;
 * op.length === 0;
 *
 * const twoArgOp = setArity(2, op);
 * twoArgOp.length === 2;
 *
 * @param  {number} arity from 0 to 9
 * @param  {Function} operation
 * @return {Function}
 */
var setArity = (0, _curry2.default)(_setArity3.default);

exports.default = setArity;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/transmute/static-2.3/setArity.js
// module id = 386
// module chunks = 0 1